/*
 * @Author: 陶慧灵
 * @Date: 2022-10-21 09:20:20
 * @LastEditors: wenbei421 346972930@qq.com
 * @LastEditTime: 2022-10-25 15:08:15
 * @Descripttion:
 * @FilePath: \src\index-examine.ts
 */
import icsChromelyRequest from '@icreate/ics-chromely-js-sdk'
import IndexExamine from './index-examine'
import { escapeSpecialCharacters } from './utils'

export default class Icd9cm3Index {
  private static like = ['ID', 'NAME', 'SPELL_CODE', 'STROKE_CODE']
  /**
   * 查询icd10诊断
   * @param category 诊断类别  1：治疗性操作 2:诊断性操作 3：手术  不传则查全部
   * @param keys：关键字
   * @param tcmOperation 中医操作 true:是 false:否
   * @returns 成功返回结果
   */
  public static query(
    category: string,
    keys: string = '',
    tcmOperation: boolean | null = null
  ): Promise<any> {
    if (icsChromelyRequest.isChromely) {
      return IndexExamine.query(
        'Icd9cm3Index',
        category,
        this.QueryCondition(category, escapeSpecialCharacters(keys), tcmOperation)
      )
    } else {
      if (tcmOperation != null || tcmOperation != undefined) {
        return IndexExamine.queryByServer('Icd9cm3Index', category, keys, this.like, {
          TCM_OPERATION_FLAG: tcmOperation ? 1 : 0
        })
      } else {
        return IndexExamine.queryByServer('Icd9cm3Index', category, keys, this.like, {})
      }
    }
  }

  /**
   * 分页查询索引
   * @param indexId: 索引id
   * @param pageIndex：page索引
   * @param pageSize：page尺寸
   * @param category 诊断类别  1：治疗性操作 2:诊断性操作；3：手术
   * @param keys：关键字
   * @param tcmOperation 中医操作 true:是 false:否
   * @returns 成功返回结果
   */
  public static page(
    pageIndex: number,
    pageSize: number,
    category: string,
    keys: string = '',
    tcmOperation: boolean | null = null
  ): Promise<any> {
    if (icsChromelyRequest.isChromely) {
      return IndexExamine.page(
        'Icd9cm3Index',
        pageIndex,
        pageSize,
        category,
        this.QueryCondition(category, escapeSpecialCharacters(keys), tcmOperation)
      )
    } else {
      if (tcmOperation != null || tcmOperation != undefined) {
        return IndexExamine.pageByServer(
          'Icd9cm3Index',
          pageIndex,
          pageSize,
          category,
          keys,
          this.like,
          {
            TCM_OPERATION_FLAG: tcmOperation ? 1 : 0
          }
        )
      } else {
        return IndexExamine.pageByServer(
          'Icd9cm3Index',
          pageIndex,
          pageSize,
          category,
          keys,
          this.like,
          {}
        )
      }
    }
  }

  /**
   * 查询条件组装
   * @param keys
   * @returns
   */
  private static QueryCondition(category: string, keys: string, tcmOperation: boolean | null = null): string {
    let conditions = []
    if (keys.trim()) {
      conditions.push(
        `(id:*${keys}* OR name:"*${keys}*" OR spellCode:*${keys}* OR strokeCode:*${keys}*)`
      )
    }
    if (tcmOperation != null || tcmOperation != undefined) {
      if (tcmOperation) {
        conditions.push(`tcmOperationFlag:1`)
      } else {
        conditions.push(`tcmOperationFlag:0`)
      }
    }
    return conditions.join(' AND ')
  }
}
